import React, { useState } from "react";
import "./index.scss";
import InputField from "../../../components/auth/InputField";
import { toast } from "react-toastify";
import apiInstance from "../../../services/apiService";
import GradientButton from "../../../components/common/UI/GradientButton";
import { useNavigate } from "react-router-dom";

const LoginWithEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) {
      toast.error("Please enter a valid email");
      return;
    }

    setLoading(true);

    try {
      const res = await apiInstance.post("auth/email/request-code", {
        email,
      });

      if (res?.data?.statusCode === 200) {
        navigate("/auth/verify-email-otp", {
          state: {
            email,
          },
        });
      }
    } catch (err: any) {
      toast.error(err?.data?.message || "There was an error. please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-with-email-container">
      <div className="img-container">
        <img src="/assets/images/login.svg" alt="" />
      </div>

      <div className="email-field">
        <label>Email</label>
        <InputField
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="abc@example.com"
          disabled={loading}
        />
      </div>

      <div className="footer-text">
        We’ll send a secure verification code to your email .By entering OTP you
        login to app.
      </div>

      <GradientButton onClick={handleSubmit} loading={loading}>
        Continue
      </GradientButton>
    </div>
  );
};

export default LoginWithEmail;
